import PropTypes from "prop-types"
import { chain, map } from "lodash"
import { IconButton, ListItem, ListItemText } from "@mui/material"
import { Clear } from "@mui/icons-material"
import { UNIVERSAL_SEARCH_RESULT } from "helpers/shapes"
import DynamicEllipsisWithTooltip from "components/dynamic-ellipsis-with-tooltip"

import "./styles.scss"

export default function SelectedPosition({ position, onIconClick, icon = <Clear fontSize="small" />, iconColor = "secondary", iconClassName, ...props }) {
  const descriptors = position?.assetClass !== "index" ? [
    chain(position)
      .pick(["ticker", "country"])
      .values()
      .compact()
      .join(" - ")
      .value() ?? "",
    chain(position)
      .pick(["sector", "country", "currency"])
      .values()
      .compact()
      .join(" - ")
      .value() ?? "",
  ] : [position?.description]

  let secondary = <>{map(descriptors, (d, i) => <span className="descriptor" key={i}>{d}</span>)}</>
  if (position?.assetClass === "index") {
    secondary = <DynamicEllipsisWithTooltip>{secondary}</DynamicEllipsisWithTooltip>
  }

  const itemText = position?.name || "Unknown Instrument"

  return <ListItem component="div" className="selected-position" {...props}>
    <ListItemText
      primary={<DynamicEllipsisWithTooltip
        title={itemText}
      >
        {itemText}
      </DynamicEllipsisWithTooltip>}
      secondary={secondary}
    />
    <IconButton color={iconColor} onClick={onIconClick} data-testid="selected-position-icon-button" className={iconClassName}>
      {icon}
    </IconButton>
  </ListItem>
}

SelectedPosition.propTypes = {
  position: UNIVERSAL_SEARCH_RESULT,
  icon: PropTypes.node,
  iconColor: PropTypes.oneOf(["default", "primary", "secondary"]),
  onIconClick: PropTypes.func,
  iconClassName: PropTypes.string,
}
